(function () {
  const config = window.FILA_SENTRY_CONFIG;
  const sdkUrl = "https://browser.sentry-cdn.com/10.41.0/bundle.min.js";

  const ignoredErrors = [
    // 브라우저 내장 / 무의미 에러
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
    "Non-Error promise rejection captured",
    "Non-Error exception captured",
    // ScrollMagic 라이브러리
    /\(ScrollMagic\.Scene\)/,
    /ScrollMagic.*triggerElement/,
    /ScrollMagic.*setClassToggle/,
    // 네트워크 에러 (사용자 환경 문제)
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed",
    "Network request failed",
    /TypeError: cancelled/,
    /AbortError/,
    // 브라우저 확장프로그램
    /chrome-extension:\/\//,
    /moz-extension:\/\//,
    /safari-extension:\/\//,
    // 공통 무의미 에러
    "Script error.",
    /^No error$/,
    /Cannot read properties of null/,
    /Cannot read property .* of null$/,
    /undefined is not an object/,
    // Shopify 내부
    /shopify\/monorail/,
    /web-pixel/,
    // Shopify shop-js (Shop Pay / user-recognition) 내부 에러 — 우리 코드 아님, 수정 불가.
    // store 도메인 프록시(www.fila.co.kr/cdn/shopifycloud/...)라 denyUrls 의 cdn.shopify.com
    // 패턴을 우회 + allowUrls(/fila.co.kr/)로 오히려 허용됨 → 메시지 기반으로 차단.
    "Invalid attempt to call recordCounter outside of context",
    "Invalid attempt to call recordGauge outside of context",
    "Invalid attempt to call log outside of context",
  ];

  const parseSampleRate = (value) => {
    const parsedValue = Number.parseFloat(value);

    if (Number.isNaN(parsedValue) || parsedValue < 0) {
      return 0;
    }

    if (parsedValue > 1) {
      return 1;
    }

    return parsedValue;
  };

  const applyCommonTags = () => {
    window.Sentry.setTags({
      app_name: "fila-theme",
      client_surface: "shopify-theme",
      shopify_page_type: config.pageType || "unknown",
      shopify_template: config.template || "unknown",
    });
  };

  const initializeSentry = () => {
    if (!window.Sentry || window.__FILA_THEME_SENTRY_INITIALIZED__) {
      return;
    }

    window.__FILA_THEME_SENTRY_INITIALIZED__ = true;

    window.Sentry.init({
      dsn: config.dsn,
      environment: config.environment || "production",
      release: config.release || undefined,
      sampleRate: 0.3,
      tracesSampleRate: 0,
      ignoreErrors: ignoredErrors,
      allowUrls: [
        /cdn\.shopify\.com\/s\/files.*\/assets\//,
        /fila\.co\.kr/,
      ],
      denyUrls: [
        /gtm\.js/i,
        /gtag\/js/i,
        /widgets\/assets/i,
        /analytics\.js/i,
        /connect\.facebook\.net/i,
        /cdn\.channel\.io/i,
        /cdn\.shopify\.com\/shopifycloud/i,
        /cdn\.shopify\.com\/s\/javascripts/i,
        /web-pixel/i,
        /monorail/i,
        /bat\.bing\.com/i,
        /kakao.*sdk/i,
        /naver.*sdk/i,
        /criteo/i,
        /amplitude/i,
      ],
      initialScope: {
        tags: {
          app_name: "fila-theme",
          client_surface: "shopify-theme",
          shopify_page_type: config.pageType || "unknown",
          shopify_template: config.template || "unknown",
        },
      },
      beforeSend: function (event) {
        var ua = navigator.userAgent || "";
        if (/HeadlessChrome|ScreenshotService|Googlebot|bingbot|Bytespider|YandexBot|AhrefsBot|SemrushBot/i.test(ua)) {
          return null;
        }

        event.tags = Object.assign({}, event.tags, {
          app_name: "fila-theme",
          client_surface: "shopify-theme",
          shopify_page_type: config.pageType || "unknown",
          shopify_template: config.template || "unknown",
        });

        return event;
      },
    });

    applyCommonTags();
  };

  if (!config || !config.enabled || !config.dsn) {
    return;
  }

  if (window.Sentry) {
    initializeSentry();
    return;
  }

  const existingScript = document.querySelector('script[data-fila-sentry-sdk="true"]');

  if (existingScript) {
    existingScript.addEventListener("load", initializeSentry, { once: true });
    return;
  }

  var script = document.createElement("script");
  script.src = sdkUrl;
  script.async = true;
  script.crossOrigin = "anonymous";
  script.dataset.filaSentrySdk = "true";
  script.addEventListener("load", initializeSentry, { once: true });
  document.head.appendChild(script);
})();
